import React from "react"

function Herotext(){
       return(
              <div className="hero-text">
                     <div className="text">
                            <p>Joseph Adeyanju</p>
                            <h2>Web</h2>
                            <h3>Devloper</h3>
                     </div>
                     <div className="desc">
                            <p>Began developing last year and have committed my time to it, From the time I wrote my first line of code. I have had a strong desire to learn this craft to the fullest. So much so that when covid-19 hit I had a choice to make, whether I dedicate my time to programming or continue walking a path I knew was not for me. I have dedicated my time to self-teaching code and I would love the opportunity to work with you as I continue to expand my knowledge of programming.</p>
                            <br/>
                            <hr/>
                     </div>
              </div>
       )
}

export default Herotext